module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_m_piebald.95ef14e0.png";